// const apiUrl = 'https://api.indianmatchmaking.co.in';
// const imageUrl = 'https://api.indianmatchmaking.co.in';
// const host = 'https://indianmatchmaking.co.in';

const apiUrl = 'https://livematchmakingapi.indianmatchmaking.co.in';
const imageUrl = 'https://livematchmakingapi.indianmatchmaking.co.in';
const host = 'https://indianmatchmaking.co.in';


// const apiUrlAddEdit = 'https://api.indianmatchmaking.co.in';

// const apiUrl = 'http://localhost:5000';
// const imageUrl = 'http://localhost:5000'
// const host = 'http://localhost:3000';

module.exports = { apiUrl, imageUrl, host }
